import { WIPPanel } from "../../components/WIPPanel";
import { ChatIcon } from "../../components/icons";

export function ChatTab() {
  return (
    <WIPPanel
      icon={<ChatIcon />}
      title="Chat is coming in a future version"
      description="This section will show in-game chat activity for this server. It does not do anything yet."
    />
  );
}
